import React from 'react';
import PropTypes from 'prop-types';

import { cmsContentParser } from '../../../../shared/utils/cms/cms';
import { formatCalloutTitle } from '../../utils/vehicle-landing-page-utils';

import { FITMENT_RESULTS_CATEGORY } from '../../constants/vehicle-landing-page-constants';

import './vehicle-landing-page-callout.scss';

function VehicleLandingPageCallout(props) {
  const { category, description, fitment, image, title } = props;
  let containerStyleName = 'container';

  if (category === FITMENT_RESULTS_CATEGORY.FITMENT_TIRES) {
    containerStyleName = 'tires-container';
  } else if (category === FITMENT_RESULTS_CATEGORY.FITMENT_PACKAGES) {
    containerStyleName = 'packages-container';
  } else if (category === FITMENT_RESULTS_CATEGORY.FITMENT_WHEELS) {
    containerStyleName = 'wheels-container';
  } else if (category === FITMENT_RESULTS_CATEGORY.FITMENT_ACCESSORIES) {
    containerStyleName = 'accessories-container';
  }

  return (
    <div styleName={containerStyleName}>
      <div styleName="image-container">
        <img
          alt={image?.altText}
          height={280}
          src={image?.url}
          styleName="product-image"
          width={280}
        />
      </div>
      <div styleName="info">
        <h1 styleName="title">
          {formatCalloutTitle({
            title,
            ...fitment,
            category
          })}
        </h1>
        <div styleName="desc">{cmsContentParser(description)}</div>
      </div>
    </div>
  );
}

VehicleLandingPageCallout.propTypes = {
  category: PropTypes.string,
  description: PropTypes.string,
  fitment: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    trim: PropTypes.string,
    year: PropTypes.string
  }),
  image: PropTypes.shape({
    altText: PropTypes.string,
    url: PropTypes.string
  }),
  title: PropTypes.string
};

export default VehicleLandingPageCallout;
